import type { HotelErrorCode } from 'app/utils/errors/HotelErrors';
import type { PackageErrorCode } from 'app/utils/errors/PackageErrors';

export type ApiErrorBody = {
  errorCode: ErrorCode;
  errorMessage: string;
  source: string;
};

export type HttpErrorBody = {
  error: string;
  message: string;
  statusCode: number;
};

export type formattedError = {
  errorTitle?: string;
  errorMessage: string;
};

export type ErrorCode = PackageErrorCode | HotelErrorCode;

export abstract class HttpError extends Error {
  status: number;

  constructor(message: string, status: number, cause?: Error) {
    super(message, { cause });

    this.status = status;
  }
}

export class HttpStringError extends HttpError {}

export class HttpJsonError<JsonType> extends HttpError {
  jsonObject: JsonType;

  constructor(
    message: string,
    status: number,
    jsonObject: JsonType,
    cause?: Error
  ) {
    super(message, status, cause);

    this.jsonObject = jsonObject;
  }
}

export class ApiError extends HttpJsonError<ApiErrorBody> {}
